import * as Sentry from "@sentry/vue";
import { createApp, nextTick } from "vue";
import CountryFlag from "vue-country-flag-next";
import { isFeatureEnabled } from "./router/navigation-guards";
import App from "@/App.vue";
import { registerPlugins } from "@/plugins";
import "@/utils/amplify";
import router from "@/router";

const app = createApp(App);

registerPlugins(app);
app.use(router);
app.component("CountryFlag", CountryFlag);

app.config.globalProperties.$posthog.onFeatureFlags(function () {
  console.log("feature flags loaded");
});

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT,
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  ignoreErrors: [
    "Token refresh is not supported when authenticated with the", // https://yetipay.sentry.io/issues/6437068264/ -> known issue, staff only
    "Request failed with status code 401", // https://yetipay.sentry.io/issues/6225535602
    "Large Render Blocking Asset", // https://yetipay.sentry.io/issues/5760261369
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: [
    "localhost",
    /^https:\/\/basecamp\.yetipay\.me/,
    /^https:\/\/basecamp\.dev01\.yeti\.host/,
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

router.beforeEach(isFeatureEnabled);

router.afterEach((to, from, failure) => {
  if (!failure) {
    nextTick(() => {
      app.config.globalProperties.$posthog.capture("$pageleave", { path: from.fullPath });
      app.config.globalProperties.$posthog.capture("$pageview", { path: to.fullPath });
    });
  }
});

app.mount("#app");

export default app;
